export default __webpack_public_path__ + "static/media/ss.276f6a76.jpeg";